import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const openedMixin = (theme: Theme) => ({
  width: 240,
  top: 56,
  paddingTop: 14,
  paddingLeft: 8,
  height: 'calc(100vh - 56px)',
  zIndex: 1002,
  overflowX: 'hidden' as const,
  overflowY: 'hidden' as const,
  backgroundColor: theme.palette.background.default,
});

const _closedMixin = (theme: Theme) => ({
  //   transition: theme.transitions.create('width', {
  //     easing: theme.transitions.easing.sharp,
  //     duration: theme.transitions.duration.leavingScreen,
  //   }),
  zIndex: 2,
  overflowX: 'hidden' as const,
  width: 30,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

export default makeStyles((theme: Theme) => ({
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  },
  resizeHandle: {
    width: '6px',
    cursor: 'col-resize',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 100,
    '&:hover, &:active': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  drawerIcon: {
    position: 'fixed',
    top: 422,
    marginRight: '4px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    padding: 6,
    zIndex: 101,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    transition: 'color 200ms ease, border-color 200ms ease',
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
    },
  },
  drawerIconOpen: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));
